import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface SchemaChangeDialogData {
  lostFields: string[];
  fieldValues: { [key: string]: any };
}

@Component({
  selector: 'sfo-schema-change-confirmation-dialog',
  standalone: true,
  imports: [MatIconModule, MatDialogModule, MatButtonModule],
  templateUrl: './schema-change-confirmation-dialog.component.html',
  styleUrls: ['./schema-change-confirmation-dialog.component.scss'],
})
export class SchemaChangeConfirmationDialogComponent {
  readonly dialogRef = inject(MatDialogRef<SchemaChangeConfirmationDialogComponent>);
  readonly data = inject<SchemaChangeDialogData>(MAT_DIALOG_DATA);

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
